import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserAuthPipe } from '../pipes/user-auth.pipe';
import { RoleName } from '../../../../common/interfaces/MainMenu';

@Directive({
  selector: '[userPermission]',
  standalone: true
})
export class UserPermissionDirective {
  private userAuthPipe = inject(UserAuthPipe);
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  hasRole = input.required<RoleName>({
    alias: 'userPermission'
  });

  constructor() {
    effect(() => {
      if (this.userAuthPipe.transform(this.hasRole())) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
